import { getSavedState } from "./localStorage.service";
import { ADMIN_USER } from "../constant/userPrivileges";

const authenticatedUser = getSavedState(ADMIN_USER);

export function isAuthenticated() {
  return Object.keys(authenticatedUser).length > 0;
}
